export const onSetAttachment = (state, action) => {
  const newAttachment = [action.payload] || [];

  if (action.payload) {
    return state.merge({ [action.target]: [...state[action.target], ...newAttachment] });
  }

  return state;
};
